import { useState, useEffect } from 'react';
import { tenant as tenantApi } from '../services/api';

const SECTORES = [
  { value: '',               label: 'Selecciona un sector...' },
  { value: 'inmobiliaria',   label: '🏠 Inmobiliaria' },
  { value: 'formacion',      label: '🎓 Formación / Academia' },
  { value: 'ecommerce',      label: '🛒 E-commerce / Tienda' },
  { value: 'viajes',         label: '✈️ Viajes / Turismo' },
  { value: 'reclutamiento',  label: '💼 Reclutamiento / RRHH' },
  { value: 'clinica',        label: '💆 Clínica / Estética' },
  { value: 'restaurante',    label: '🍽️ Restaurante / Catering' },
  { value: 'servicios',      label: '⚙️ Servicios profesionales' },
  { value: 'otro',           label: '📋 Otro' },
];

export default function Config({ permisos }) {
  const [form, setForm] = useState({
    nombre_agente:      '',
    especialidad:       '',
    nombre_empresa:     '',
    zona_geografica:    '',
    objetivo:           '',
    modulo_catalogo:    false,
    modulo_inventario:  false,
    modulo_citas:       true,
    modulo_coordenadas: false,
    prompt_personalizado: '',
    google_calendar:    false,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState('');

  useEffect(() => {
    tenantApi.getMe().then(data => {
      setForm(f => ({
        ...f,
        nombre_agente:        data.nombre_agente         || '',
        especialidad:         data.especialidad          || '',
        nombre_empresa:       data.nombre_empresa        || '',
        zona_geografica:      data.zona_geografica       || '',
        objetivo:             data.objetivo              || '',
        modulo_catalogo:      data.modulo_catalogo       || false,
        modulo_inventario:    data.modulo_inventario     || false,
        modulo_citas:         data.modulo_citas          !== false,
        modulo_coordenadas:   data.modulo_coordenadas    || false,
        prompt_personalizado: data.prompt_personalizado  || '',
        google_calendar:      data.google_calendar       || false,
      }));
      setLoading(false);
    });
  }, []);

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSave = async () => {
    setSaving(true);
    setMsg('');
    const res = await tenantApi.update(form);
    if (res.status === 'ok') setMsg('✓ Cambios guardados correctamente');
    else setMsg('✗ Error al guardar');
    setSaving(false);
    setTimeout(() => setMsg(''), 3000);
  };

  if (loading) return <div className="content" style={{ color: 'var(--text3)' }}>Cargando...</div>;

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Mi Agente</div>
          <div className="page-sub">Configura la identidad y comportamiento de tu agente</div>
        </div>
      </div>
      <div className="content">

        {/* ── IDENTIDAD ── */}
        <div className="card" style={{ marginBottom: '16px' }}>
          <div className="card-title">Identidad del agente</div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Nombre del agente</label>
              <input className="form-input" placeholder="Iker, Sara, Asistente..."
                value={form.nombre_agente} onChange={e => set('nombre_agente', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Nombre de tu empresa</label>
              <input className="form-input" placeholder="Mi Empresa S.L."
                value={form.nombre_empresa} onChange={e => set('nombre_empresa', e.target.value)} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Especialidad / Sector</label>
              <select className="form-input" value={form.especialidad}
                onChange={e => set('especialidad', e.target.value)} style={{ cursor: 'pointer' }}>
                {SECTORES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
              {form.especialidad && (
                <div style={{ fontSize: 11, color: 'var(--accent)', marginTop: 6 }}>
                  Sector: <strong>{form.especialidad}</strong>
                </div>
              )}
            </div>
            <div className="form-group">
              <label className="form-label">Zona geográfica</label>
              <input className="form-input" placeholder="Cantabria, Madrid, España..."
                value={form.zona_geografica} onChange={e => set('zona_geografica', e.target.value)} />
            </div>
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Objetivo principal del agente</label>
            <input className="form-input"
              placeholder="asesorar clientes y convertir interesados en citas..."
              value={form.objetivo} onChange={e => set('objetivo', e.target.value)} />
          </div>
        </div>

        {/* ── MÓDULOS ── */}
        <div className="card" style={{ marginBottom: '16px' }}>
          <div className="card-title">Módulos activos</div>
          {[
            { key: 'modulo_catalogo',    name: 'Catálogo / Base de conocimiento', desc: 'FAISS con tus productos, propiedades o servicios' },
            { key: 'modulo_inventario',  name: 'Inventario',                      desc: 'Consulta de stock y precios en tiempo real' },
            { key: 'modulo_citas',       name: 'Citas y reservas',                desc: 'Agenda citas con Google Calendar' },
            { key: 'modulo_coordenadas', name: 'Búsqueda geográfica',             desc: 'Encuentra opciones cercanas por ubicación' },
          ].map(m => (
            <div className="toggle-wrap" key={m.key}>
              <div className="toggle-info">
                <div className="toggle-name">{m.name}</div>
                <div className="toggle-desc">{m.desc}</div>
              </div>
              <label className="toggle">
                <input type="checkbox" checked={form[m.key]} onChange={e => set(m.key, e.target.checked)} />
                <span className="slider-toggle"></span>
              </label>
            </div>
          ))}
        </div>

        {/* ── INSTRUCCIONES ── */}
        <div className="card" style={{ marginBottom: '16px' }}>
          <div className="card-title">Instrucciones adicionales</div>
          <textarea className="form-input" rows="7" style={{ resize: 'vertical', lineHeight: '1.6' }}
            placeholder={'Personaliza el comportamiento de tu agente. Ejemplos:\n- Responde siempre en inglés y español\n- Si preguntan por financiación, indica que llamen al 612345678\n- Horario de visitas: lunes a viernes 10h-18h\n- Usa siempre un tono formal y exclusivo'}
            value={form.prompt_personalizado} onChange={e => set('prompt_personalizado', e.target.value)} />
          <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>
            Estas instrucciones se añaden al comportamiento base del agente según tu sector.
          </div>
        </div>

        {/* ── INTEGRACIONES ── */}
        <div className="card" style={{ marginBottom: '16px' }}>
          <div className="card-title">Integraciones</div>
          <div className="toggle-wrap">
            <div className="toggle-info">
              <div className="toggle-name">Google Calendar</div>
              <div className="toggle-desc">{form.google_calendar ? '✓ Conectado' : 'No conectado'}</div>
            </div>
            {form.google_calendar ? (
              <button className="btn btn-danger" style={{ fontSize: 11, padding: '5px 12px' }}
                onClick={async () => {
                  const token = localStorage.getItem('devit_token');
                  await fetch('https://bot.devit.es/api/calendar/disconnect', {
                    method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` },
                  });
                  set('google_calendar', false);
                }}>
                Desconectar
              </button>
            ) : (
              <button className="btn btn-ghost" style={{ fontSize: 11, padding: '5px 12px' }}
                onClick={async () => {
                  const token = localStorage.getItem('devit_token');
                  const res = await fetch(`https://bot.devit.es/api/calendar/connect?authorization=Bearer%20${token}`);
                  const data = await res.json();
                  if (data.auth_url) window.location.href = data.auth_url;
                }}>
                Conectar
              </button>
            )}
          </div>
        </div>

        <div className="divider"></div>
        {msg && (
          <div className={`alert ${msg.startsWith('✓') ? 'alert-success' : 'alert-warn'}`} style={{ marginBottom: 12 }}>
            {msg}
          </div>
        )}
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Guardando...' : '✓ Guardar cambios'}
          </button>
          <button className="btn btn-ghost" onClick={() => window.location.reload()}>Descartar</button>
        </div>
      </div>
    </div>
  );
}
